import {ChartData} from "chart.js/auto";
import {GenericSortingService} from "../../../../../../../_services/generic-sorting.service";
import {SalesDto} from "../../../../models/sales/sales-dto";
import {SalesWrapper} from "../../../../utils/sales/sales-wrapper";
import {LinkedDtoRepository} from "../../../../../common/repositories/linked-dto-repository";
import {ColorMapService} from "../../../../../common/colors/color-map.service";

export class DistributionDatasetProcessor {
  static verifyDatasetContainsOnlyPositiveValues(dataset: ChartData<"doughnut">): boolean {
    return dataset.datasets![0].data.every((x) => x >= 0);
  }

  static processPieChartDataset(groupKey: keyof SalesDto, salesWrapper: SalesWrapper, linkedDtoRepository: LinkedDtoRepository<any>, colorMapService: ColorMapService): ChartData<"doughnut"> {
    //let data = this.buildRawPieChartData(baseOrderElementsWrapper.getBaseOrderElements(), (baseOrderElement) => baseOrderElement[groupKey] as string??"unbekannt", (baseOrderElement) => SingleEventAnalysisUtils.getRevenue(baseOrderElement));

    let data = this.buildRawPieChartData(salesWrapper, groupKey);
    DistributionDatasetProcessor.sortPieChartByValue(data);
    DistributionDatasetProcessor.setColorOfPieChart(data, colorMapService, groupKey)
    DistributionDatasetProcessor.setLabelsOfPieChart(data, groupKey, linkedDtoRepository);
    return data as ChartData<"doughnut">;
  }

  static setColorOfPieChart(data: ChartData<"pie"> | ChartData<"doughnut">, colorMapService: ColorMapService, groupKey: string) {
    let colorCount = data.labels!.length;
    data.datasets[0].backgroundColor = [];

    for (let i = 0; i < colorCount; i++) {
      let dataset = data.datasets[0].backgroundColor as string[];
      dataset.push(colorMapService.getColorAndStore(i, colorCount, data.labels![i] as string, groupKey))
    }
  }

  static setLabelsOfPieChart(data: ChartData, groupKey: keyof SalesDto, linkedDtoRepository: LinkedDtoRepository<any>) {
    data.labels = data.labels!.map((label) => linkedDtoRepository.getName(label as string, groupKey));
  }

  static sortPieChartByValue(data: ChartData) {
    let x = [data.datasets[0].data, data.labels]

    // Sort PieChart By Revenue
    x = GenericSortingService.sortMultipleArrays(x as [[], []], 0, true)
    data.datasets[0].data = x[0] as number[]
    data.labels = x[1]
  }

  private static buildRawPieChartData(salesWrapper: SalesWrapper, key: keyof SalesDto): ChartData<"doughnut"> | ChartData<"pie"> {
    let data: ChartData<"doughnut"> | ChartData<"pie"> = {
      labels: [], datasets: [
        {
          data: [],

        }
      ]
    };
    if (salesWrapper.quantitativeBaseOrderCacheVO.dataCache[key] === undefined) {
      console.error("No data for key: " + key);
    }

    for (let val of salesWrapper.quantitativeBaseOrderCacheVO.dataCache[key]!) {
      data.labels!.push(val.id);
      data.datasets[0].data.push(val.value);
    }
    return data;
  }

}
